<div class="d-flex flex-column justify-content-between max-view-height">
    <div class="container">
        <div class="row justify-content-between">
            <app-breadcrumb [crumbs]="crumbs" class="col"></app-breadcrumb>
            <div class="col-auto">
                <a class="btn btn-secondary" routerLink="/{{Routenames.seire}}/all">Alle checkpoints tonen</a>
            </div>
        </div>

        <table class="table table-hover table-last-col table-add-row">
            <thead>
                <tr>
                    <th>Bedrijfsnaam</th>
                    <th>Platformnaam</th>
                    <th>Status</th>
                    <th class="text-end d-none d-md-table-cell">SSL vervaldatum</th>
                    <th class="d-none d-md-table-cell">Productie-URL</th>
                    <th class="d-none d-md-table-cell">Acceptatie-URL</th>
                    <th class="d-none d-md-table-cell">Test-URL</th>
                    <th class="d-none d-md-table-cell">Local-URL</th>
                </tr>
            </thead>
            <tbody>
                @for (platform of sortedPlatforms(); track platform.id) {
                    <tr>
                        <td><a class="text-dark" routerLink="/{{Routenames.companies}}/{{platform.company?.id}}">{{platform.company?.name}}</a></td>
                        <td><a class="text-dark" routerLink="/{{Routenames.seire}}/{{platform.id}}">{{platform.name}}</a></td>
                        <td class="pb-0 pt-1">
                            <div class="d-flex gap-2">
                                @for (levelEnum of levelEnums; track levelEnum) {
                                    <div
                                        [class]="levelEnum | PlatformLevelStatusPipe: platform"
                                        [ngbTooltip]="levelEnum"
                                        [queryParams]="{level: levelEnum}"
                                        class="curpoint"
                                        routerLink="/{{Routenames.seire}}/{{platform.id}}">
                                    </div>
                                }
                            </div>
                        </td>
                        <td [class]="(platform.closest_ssl_expiry_date | minDate : platform.closest_acceptance_ssl_expiry_date) | sslValidUntil" class="text-end d-none d-md-table-cell">
                            {{((platform.closest_ssl_expiry_date | minDate : platform.closest_acceptance_ssl_expiry_date) | daysFromNow) ?? '-'}}
                        </td>
                        <td class="d-none d-md-table-cell"><a [href]="platform.prod_url" class="platform-urls" target="_blank">{{platform.prod_url | urlPrefixStripping}}</a></td>
                        <td class="d-none d-md-table-cell"><a [href]="platform.acc_url" class="platform-urls" target="_blank">{{platform.acc_url | urlPrefixStripping}}</a></td>
                        <td class="d-none d-md-table-cell"><a [href]="platform.test_url" class="platform-urls" target="_blank">{{platform.test_url | urlPrefixStripping}}</a></td>
                        <td class="d-none d-md-table-cell"><a [href]="platform.local_url" class="platform-urls" target="_blank">{{platform.local_url | urlPrefixStripping}}</a></td>
                    </tr>
                } @empty {
                    <tr>
                        <td class="text-center" colspan="99">
                            @if (platforms() === null) {
                                Aan het laden...
                            } @else {
                                Geen platformen gevonden
                            }
                        </td>
                    </tr>
                }
                @if (Features.PlatformsSave | hasFeature) {
                    <tr class="d-none d-md-table-row">
                        <td colspan="99">
                            <button class="w-100 btn btn-secondary" routerLink="/{{Routenames.platforms}}/new">
                                Platform toevoegen <i class="fas fa-plus"></i>
                            </button>
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
    @if (Features.Servers | hasFeature) {
    <div class="container servers">
        <table class="table table-hover table-last-col table-add-row">
            <thead>
                <tr>
                    <th class="text-end">Server IP</th>
                    <th class="d-none d-md-table-cell">Server name</th>
                    <th class="text-end">Apache</th>
                    <th class="d-none d-md-table-cell">Apache module</th>
                    <th class="text-end">Apache php</th>
                    <th class="text-end">Os</th>
                    <th class="text-end">Php</th>
                    <th class="text-end">Mysql</th>
                    <th class="text-end">Updates</th>
                    <th class="text-end">Last updated</th>
                </tr>
            </thead>
            <tbody>
                @for (server of servers(); track server.ip) {
                    <tr>
                        <td class="text-end">{{server.ip}}<br class="d-md-none"><span class="d-md-none">{{server.server_name}}</span></td>
                        <td class="d-none d-md-table-cell">{{server.server_name}}</td>
                        <td class="text-end">{{server.apache}}<br class="d-md-none"><span class="d-md-none">{{server.apache_module}}</span></td>
                        <td class="d-none d-md-table-cell">{{server.apache_module}}</td>
                        <td class="text-end">{{server.apache_php}}</td>
                        <td class="text-end">{{server.os}}</td>
                        <td class="text-end">{{server.php}}</td>
                        <td class="text-end">{{server.mysql}}</td>
                        <td class="text-end">{{server.updates}}</td>
                        <td [class.text-danger]="isOlderThan2Days(server.updated_at)" class="text-end">{{server.updated_at | date:'EEE d MMM HH:mm'}}</td>
                    </tr>
                } @empty {
                    <tr>
                        <td colspan="99">Geen servers beschikbaar</td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
    }
</div>
